import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { services } from '../data/services';
import { EndNote } from '../components/EndNote';
export function About() {
  const [openNumber, setOpenNumber] = useState<string | null>(null);
  return <div data-id="element-62" data-mp="29hsnq16m5c9h">
      <header className="mx-auto max-w-page px-6 pb-16 pt-14 md:px-10 md:pb-24 md:pt-24" data-id="element-63" data-mp="2eiq54bjsu29x">
        <h1 className="max-w-3xl font-display text-3xl font-medium uppercase leading-[1.1] md:text-5xl" data-id="element-64" data-mp="2egdqo8d92a1m">
          A creative experiential production studio blending innovative
          strategy, elevated design and{' '}
          <span className="text-lilac" data-id="element-65" data-mp="2samqlwqypdxc">seamless operations</span>.
        </h1>
      </header>

      <section className="mx-auto max-w-page px-6 pb-20 md:px-10 md:pb-32" data-id="element-66" data-mp="2x8y20bwwnwho">
        <div className="grid gap-8 md:grid-cols-12" data-id="element-67" data-mp="2xb12xqzlja16">
          <h2 className="md:col-span-3 text-[0.65rem] uppercase tracking-micro text-muted" data-id="element-68" data-mp="1gtwvp9rzo8j1">
            What we do
          </h2>

          <ul className="md:col-span-9 border-t border-line" data-id="element-69" data-mp="1lrya3hegzjo6">
            {services.map(service => {
            const isOpen = openNumber === service.number;
            return <li key={service.number} className="border-b border-line" data-id="element-70" data-mp="1pkjlmzc34j91">
                  <h3 data-id="element-71" data-mp="23jjc8cj5r87u">
                    <button type="button" onClick={() => setOpenNumber(isOpen ? null : service.number)} aria-expanded={isOpen} aria-controls={`service-${service.number}`} className="group flex w-full items-center gap-5 py-5 text-left transition-colors hover:text-lilac" data-id="element-72" data-mp="23jroq3bdcbii">
                      <span className="font-display text-lg uppercase leading-none md:text-2xl" data-id="element-73" data-mp="2i6ulu8vs4i5b">
                        {service.title}
                      </span>
                      <span className="ml-auto shrink-0 text-muted transition-colors group-hover:text-lilac" data-id="element-74" data-mp="2w4svx232hsf0">
                        {isOpen ? <MinusIcon size={16} data-id="element-75" data-mp="1ovo3w82sip82" /> : <PlusIcon size={16} data-id="element-76" data-mp="1svq5yicftknv" />}
                      </span>
                    </button>
                  </h3>

                  {isOpen && <div id={`service-${service.number}`} className="pb-7" data-id="element-77" data-mp="22m1dsfz8se01">
                      <p className="max-w-2xl leading-relaxed text-muted" data-id="element-78" data-mp="22o4blm6mzbfb">
                        {service.description}
                      </p>
                      <ul className="mt-5 grid gap-x-10 gap-y-1.5 sm:grid-cols-2" data-id="element-79" data-mp="2cjfpk2a80em0">
                        {service.capabilities.map(capability => <li key={capability} className="text-sm text-cream/80" data-id="element-80" data-mp="2gjpzfq14vp65">
                            {capability}
                          </li>)}
                      </ul>
                    </div>}
                </li>;
          })}
          </ul>
        </div>
      </section>

      <EndNote data-id="element-81" data-mp="ewwqhovhzjor" />
    </div>;
}